import { stats } from '../../data/content';
import './Stats.css';

function Stats() {
  return (
    <section className="stats">
      <div className="container">
        <div className="stats-bar">
          {stats.map((item) => (
            <span key={item} className="stat-item">{item}</span>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;
